/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationBoxDimensionResVo } from './AdminStockAdjustLocationBoxDimensionResVo';
import {
    AdminStockAdjustLocationBoxDimensionResVoFromJSON,
    AdminStockAdjustLocationBoxDimensionResVoFromJSONTyped,
    AdminStockAdjustLocationBoxDimensionResVoToJSON,
    AdminStockAdjustLocationBoxDimensionResVoToJSONTyped,
} from './AdminStockAdjustLocationBoxDimensionResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationBoxDimensionResVo
 */
export interface ResponseAdminStockAdjustLocationBoxDimensionResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationBoxDimensionResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationBoxDimensionResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationBoxDimensionResVo}
     * @memberof ResponseAdminStockAdjustLocationBoxDimensionResVo
     */
    data?: AdminStockAdjustLocationBoxDimensionResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationBoxDimensionResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationBoxDimensionResVo(value: object): value is ResponseAdminStockAdjustLocationBoxDimensionResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationBoxDimensionResVoFromJSON(json: any): ResponseAdminStockAdjustLocationBoxDimensionResVo {
    return ResponseAdminStockAdjustLocationBoxDimensionResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationBoxDimensionResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationBoxDimensionResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationBoxDimensionResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationBoxDimensionResVoToJSON(json: any): ResponseAdminStockAdjustLocationBoxDimensionResVo {
    return ResponseAdminStockAdjustLocationBoxDimensionResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationBoxDimensionResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationBoxDimensionResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationBoxDimensionResVoToJSON(value['data']),
    };
}

